import { useContext } from "react";
import AppContext from "../components/contextProvider/AppContextProvider/AppContext";

export default function useAppContext() {
  return useContext(AppContext);
}
